import React from 'react';
import Auth0LockPlaygroundHomepage from 'auth0-lock-playground';

const settings = {
  defaultsLogosBaseUrl: 'https://cdn2.auth0.com/website/playground/'
};
const LockPlaygroundHomepage = () => <Auth0LockPlaygroundHomepage {...settings} />;

export default LockPlaygroundHomepage;



// WEBPACK FOOTER //
// ./src/components/LockPlaygroundHomepage/LockPlaygroundHomepage.js